import { FaqItem } from '../../../types/question';
import { ImageType } from '../../../types/image';
import { PortableTextType } from '../../../types/sanityInternal';
import AccordionSection from '../accordion-section';
import buildFaqPageSchema from '../../structured-data/utils/build-faq-page-schema';
import StructuredData from '../../structured-data';

type CommonQuestionsSectionProps = {
  accordionId: string;
  image?: ImageType | null;
  questions: FaqItem[];
  summary?: PortableTextType[];
  title: string | undefined;
  withBorder?: boolean;
  isTwoColumn?: boolean;
  initialVisible?: number;
};

const CommonQuestionsSection = ({
  accordionId,
  image,
  questions,
  summary,
  title,
  withBorder,
  isTwoColumn,
  initialVisible,
}: CommonQuestionsSectionProps) => {
  if (!questions.length) {
    return null;
  }

  return (
    <>
      <AccordionSection
        accordionId={accordionId}
        image={image || undefined}
        initialVisible={initialVisible}
        items={questions}
        summary={summary}
        title={title}
        withBorder={withBorder}
        isTwoColumn={isTwoColumn}
      />
      <StructuredData data={buildFaqPageSchema(questions)} />
    </>
  );
};

export default CommonQuestionsSection;
